import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const p = (m) => /* @__PURE__ */ o(r, { ...m, children: /* @__PURE__ */ o("path", { d: "m9.99457 14.1689-1.17062-1.1706-4.66041-4.67143 1.17062-1.17062 4.66041 4.66045L14.666 7.15625l1.1706 1.17062-4.6604 4.67143-1.18163 1.1706Z" }) });
export {
  p as CustomDown
};
//# sourceMappingURL=CustomDown.js.map
